import { Button, Col, Row, Spin, Table, Typography } from 'antd';
import React, { useEffect } from 'react';
import { getRequieredProgram } from 'services/auth';
import { PromiseAllSettled } from 'utils/Polyfills';
import ReqAppConfig from '../config/required_app.config';
import { startAgent } from '../utils';

function Download() {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Typography.Paragraph>
          서비스 이용에 필요한 프로그램을 다운받을 수 있습니다.
          <br />
          현재 사용하시는 운영 체제는 <Typography.Text mark>Windows 10, 64bits</Typography.Text>
          입니다. 해당 지원 프로그램을 설치하세요.
        </Typography.Paragraph>
      </Col>
      <Col span={24}>
        <DownloadTable />
      </Col>
    </Row>
  );
}

export function DownloadTable({ onCheckProgram, ...res }) {
  const [dataSource, setDataSource] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setLoading(true);

    // mgmt로 부터 현재 확인해야하는 프로그램 목록을 가져온다.
    const loadingFunc = async () => {
      const programs = await getRequieredProgram();
      return programs;
    };

    loadingFunc().then((programs) => {
      const dataLoading = Object.entries(ReqAppConfig.requiredProgram(programs)).map(
        async ([k, v]) => {
          const state = v.onInstallCheck
            ? (await PromiseAllSettled(await v.onInstallCheck(window)))
                .map((result) => result.value)
                .some(Boolean)
            : true;
          return {
            key: k,
            ...v,
            state,
          };
        },
      );

      PromiseAllSettled(dataLoading).then((data) => {
        setDataSource(data.map((d) => d.value));
        setLoading(false);
        onCheckProgram?.(data.map((d) => d.value.state).every(Boolean));
      });
    });
  }, []);

  const columns = [
    {
      title: '프로그램 이름',
      dataIndex: 'title',
      width: 140,
    },
    {
      title: '설명',
      dataIndex: 'description',
    },
    {
      title: '설치 상태',
      dataIndex: 'state',
      render: (text, record) => {
        const agentChk =
          record.key === 'vsclient' ? (
            <>
              <Typography.Paragraph>
                알 수 없음
                <Typography.Text type="secondary">
                  (설치되었으나 프로그램이 실행되지 않았을 수 있습니다. 접속을 위해 프로그램을
                  실행하십시오.)
                </Typography.Text>
              </Typography.Paragraph>
              <Button
                size="small"
                onClick={(e) => {
                  if (e) {
                    startAgent(2).then(() => {
                      window.location.reload();
                    });
                  }
                }}
              >
                프로그램 실행
              </Button>
            </>
          ) : (
            '설치되지 않음'
          );
        const stateMap = {
          true: '설치됨',
          false: agentChk,
        };
        return stateMap[text];
      },
    },
    {
      title: '다운로드',
      dataIndex: 'downloadPath',
      render: (path) => (
        <Button target="_blank" href={path}>
          다운로드
        </Button>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <Table
        rowKey="key"
        pagination={false}
        dataSource={dataSource}
        columns={columns}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...res}
      />
    </Spin>
  );
}

export default Download;
